import $ from 'jquery';

export function newsletterSettingsSelection(){
	$(document).ready(function() {
		$(".checkbox-input input").each(function() {
			$(this).change(function() {
				if($(this).is(':checked')){
					$(this).prop('checked', true)
				} else {
					$(this).prop('checked', false)
				}
			});
		});
	});
}